import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { lazy, Suspense } from "react";
import cn from "clsx";
import { Skeleton } from "@crehana/ui";
import { useMainMenuContext } from "../../../../../../hooks";
import { jsx as _jsx } from "react/jsx-runtime";
var InboxWithPusherContext = /*#__PURE__*/lazy(function () {
  return import(/* webpackChunkName: "main-menu-inbox-with-notifications" */"./InboxWithPusherContext");
});
var LazyInboxWithNotifications = function LazyInboxWithNotifications(props) {
  var _useMainMenuContext = useMainMenuContext(),
    themeName = _useMainMenuContext.themeName;
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: /*#__PURE__*/_jsx(Skeleton, {
      className: cn('w-32 h-32 rounded-full', props.className),
      isDark: themeName.nav === 'dark'
    }),
    children: /*#__PURE__*/_jsx(InboxWithPusherContext, _objectSpread({}, props))
  });
};
export default LazyInboxWithNotifications;